import {Button, Card, Input, Modal, Space, Table} from "antd";
import {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {t} from "i18next";
import SimpleLayout from "../../core/components/layout/SimpleLayout";
import ApiService from "../../core/service/ApiService";
import {useUser} from "../../core/context/UserContext";
import RoleCreateEdit from "./RoleCreateEdit";

export default function RoleList()
{
    const history = useHistory();
    const [roles, setRoles] = useState([]);
    const [filteredData, setFilteredData] = useState([])
    const {firmSettings} = useUser();

    // Düzenleme ayrı sayfaya gitmeden modalda açılır; liste ve filtre olduğu yerde kalır.
    const [editRoleId, setEditRoleId] = useState(null);

    const getRoles = async () => {
        const res = await ApiService.Role.GetRoleList();

        if(res.success)
        {
            setRoles(res.data);
        }
    }

    useEffect(() => {
        getRoles()
    }, [])

    useEffect(() => {
        setFilteredData(roles)
    }, [roles])

    const renderAction = (row) => {
        return (
            <Space>
                <a key="edit" onClick={() => setEditRoleId(row.id)}>{t('Edit')}</a>
            </Space>
        )
    }

    const editingRole = roles.find(x => x.id === editRoleId);

    return (
        <SimpleLayout>
            <Card>
                <Space style={{marginBottom: 16}}>
                    <Button size={'small'} onClick={() => {history.push(`/app/system/roles/create`)}} type={'primary'}>{t('New')}</Button>
                    <Button size={'small'} onClick={getRoles}>{t('Refresh')}</Button>
                    <Input
                        size={'small'}
                        placeholder={t('Search')}
                        onChange={(e) => {
                            if(!e.target.value)
                            {
                                setFilteredData(roles);
                                return
                            }
                            setFilteredData(roles.filter(x => x.name.toLocaleUpperCase(firmSettings?.locale).includes(e.target.value.toLocaleUpperCase(firmSettings?.locale))))
                        }}
                    />
                </Space>
                <Table
                    size={'small'}
                    dataSource={filteredData}
                    pagination={false}
                    rowKey={'id'}
                    columns={[
                        {
                            key: 'name',
                            dataIndex: 'name',
                            title: t('Name'),
                            defaultSortOrder: 'ascend',
                            sorter: (a, b) => (a.name ?? '').localeCompare(b.name ?? '', firmSettings?.locale)
                        },
                        {key: '#', dataIndex: '#', title: '#', render: (text, row) => renderAction(row)},
                    ]}
                />
            </Card>

            <Modal
                open={!!editRoleId}
                title={`${t('Edit Role')}${editingRole ? ` - ${editingRole.name}` : ''}`}
                width={800}
                footer={null}
                destroyOnClose={true}
                onCancel={() => setEditRoleId(null)}
            >
                <RoleCreateEdit
                    roleId={editRoleId}
                    embedded={true}
                    onSaved={() => {
                        setEditRoleId(null);
                        getRoles();
                    }}
                />
            </Modal>
        </SimpleLayout>
    )
}
